import { render, staticRenderFns } from "./coupon_home.vue?vue&type=template&id=6a66d010&scoped=true&"
import script from "./coupon_home.vue?vue&type=script&lang=js&"
export * from "./coupon_home.vue?vue&type=script&lang=js&"
import style0 from "./coupon_home.vue?vue&type=style&index=0&id=6a66d010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a66d010",
  null
  
)

export default component.exports